// Helper functions to convert DTOs to FormData
export const createFamilyRelationToFormData = (dto) => {
    const formData = new FormData();
    formData.append('personId', dto.personId);
    formData.append('name', dto.name);
    formData.append('dateOfBirth', dto.dateOfBirth instanceof Date ? dto.dateOfBirth.toISOString() : dto.dateOfBirth);
    formData.append('relationship', dto.relationship);
    if (dto.dateSincePartner) {
        formData.append('dateSincePartner', dto.dateSincePartner instanceof Date
            ? dto.dateSincePartner.toISOString()
            : dto.dateSincePartner);
    }
    if (dto.picture)
        formData.append('picture', dto.picture);
    return formData;
};
export const updateFamilyRelationToFormData = (dto) => {
    const formData = new FormData();
    formData.append('id', dto.id);
    formData.append('personId', dto.personId);
    formData.append('name', dto.name);
    formData.append('dateOfBirth', dto.dateOfBirth instanceof Date ? dto.dateOfBirth.toISOString() : dto.dateOfBirth);
    formData.append('relationship', dto.relationship);
    if (dto.dateSincePartner) {
        formData.append('dateSincePartner', dto.dateSincePartner instanceof Date
            ? dto.dateSincePartner.toISOString()
            : dto.dateSincePartner);
    }
    if (dto.picture)
        formData.append('picture', dto.picture);
    return formData;
};
